import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import clsx from 'clsx';
import { useClickable } from '../hooks/use-clickable.js';
import { buttonReset } from './button-reset.css.js';

/**
 * ButtonPrimitive is an unstyled (“headless”) component that handles button functionality and a11y concerns.
 * Use a ButtonPrimitive if you need a component that behaves like a button but doesn't match UI3 styling
 * @see https://fpl.figma.design/components/primitives/button/
 */
const ButtonPrimitive = forwardRef(({ children, className, type = 'button', ...props }, ref) => {
    const buttonProps = useClickable({ ...props, type });
    return (jsx("button", { "data-fpl-component": "primitive", ...buttonProps, ref: ref, type: type, className: clsx(buttonReset, className), "aria-disabled": props['aria-disabled'] || props.disabled || undefined, children: children }));
});
ButtonPrimitive.displayName = 'ButtonPrimitive';

export { ButtonPrimitive };
//# sourceMappingURL=button-primitive.js.map
